import { SET_CHAT_THEME, GET_CHAT_THEME } from './action';

// Initial state
const initialState = {
  chatTheme: 'BurrowBackLight1' // Default theme
};

/**
 * Theme reducer for handling chat background theme state
 * 
 * @param {Object} state - Current state
 * @param {Object} action - Action to process
 * @returns {Object} - New state
 */
const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHAT_THEME:
      return {
        ...state,
        chatTheme: action.payload
      };
      
    case GET_CHAT_THEME:
      return {
        ...state,
        chatTheme: action.payload
      };
      
    default:
      return state;
  }
};

export default themeReducer;
